import { toast } from 'react-toastify';

import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import useClientState from '@/state/useClientState';
import { toastErrorOptions, toastSuccessOptions } from '@/utils/toastOptions';

export default function usePutWtsEenheden() {
  const deleteWtsEenheden = useClientState((state) => state.deleteWtsEenheden);
  const { fetchWithAuth } = useFetchWithAuth();
  const wtsUrl = '/eenheid/v1/wtsUitsluiting';
  const putWts = async (nummers: string[], wtsUitgesloten: boolean) => {
    return fetchWithAuth(wtsUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ nummers, wtsUitgesloten }),
    });
  };
  return {
    async createWts(nummers: string[], wtsUitgesloten: boolean) {
      const response = await putWts(nummers, wtsUitgesloten);
      if (response.ok) {
        const message = await response.json();
        if (message === 'SUCCES') toast.success(`WTS status wijziging wordt verwerkt.`, toastSuccessOptions);
        else toast.error('WTS status wijzigen mislukt.', toastErrorOptions);
      }
    },
    async deleteWts(nummers: string[]) {
      const response = await putWts(nummers, false);
      const deleted = Boolean(response.ok);
      if (deleted) {
        const message = await response.json();
        if (message === 'SUCCES') {
          toast.success(`WTS uitsluiting wordt verwijderd.`, toastSuccessOptions);
          deleteWtsEenheden(nummers);
        } else toast.error('WTS status wijzigen mislukt.', toastErrorOptions);
      }
    },
  };
}
